import {warnAndRedirectAfterInaccessiblePageOpen} from 'auth/capabilities/InaccessibleFeaturesActions';
import BenchlingConfig from 'BenchlingConfig';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';
import EntityStore from 'stores/EntityStore';

export const ChemistryRoutes: RouteBundle = {
  domain: 'chemistry',
  routes: [
    {
      urlPattern: 'salts/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.saltLibrary();
      },
    },
    {
      urlPattern: 'solvents/listing',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        EditorRoutes.solventLibrary();
      },
    },
    {
      urlPattern: 'salts/create/bulk-csv',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        if (!EntityStore.currentUser()?.isTenantAdmin) {
          warnAndRedirectAfterInaccessiblePageOpen(
            'You must be a tenant admin to import salts. Please contact your tenant admin for more information.'
          );
          return;
        }
        EditorRoutes.saltCreateFromCSVPage();
      },
    },
    {
      urlPattern: 'solvents/create/bulk-csv',
      handler: () => {
        if (!BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE_SALT_FORMS) {
          warnAndRedirectAfterInaccessiblePageOpen('Chemistry features are not enabled.');
          return;
        }
        if (!EntityStore.currentUser()?.isTenantAdmin) {
          warnAndRedirectAfterInaccessiblePageOpen(
            'You must be a tenant admin to import solvents. Please contact your tenant admin for more information.'
          );
          return;
        }
        EditorRoutes.solventCreateFromCSVPage();
      },
    },
  ],
};
